import langString from "./langString";

export const checkNullData = (value: any) =>
  value ? value : langString("notspecific");
